import ResourceHeader from '~scripts/components/resource-header';

ResourceHeader.init();
